
const TYPES = {
    ServiceConfiguration: Symbol.for('ServiceConfiguration'),
    KotennaApi: Symbol.for('KotennaApi'),

    ConsoleUI: Symbol.for('ConsoleUI'),

    VHostWorker: Symbol.for('VHostWorker'),
    AliasWorker: Symbol.for('AliasWorker'),
    ProviderWorker: Symbol.for('ProviderWorker'),
    AuthenticationServer: Symbol.for('AuthenticationServer'),

    CloudProvidertWorker: flavour => Symbol.for(`CloudProviderWorker_${flavour}`),


    AppDigitalOceanWordpress: Symbol.for('AppDigitalOceanWordpress'),

};

export default TYPES;